import { PublicPageLoader } from '@/features/public-pages/components/PublicPageLoader';

/**
 * Public Benefits page (`/benefits`), fully CMS-driven (MYN-198). Every
 * section renders from the `benefits` page's content via the public read
 * API - no hardcoded copy lives here. Loading/not-published/error states are
 * shared across every public page via `PublicPageLoader`.
 */
export function BenefitsPage() {
  return <PublicPageLoader slug="benefits" />;
}
